module.exports = __webpack_public_path__ + "static/media/tic-white-icon.bcff6389.svg";